var moduleMap = {
	"./atoms": () => {
		return Promise.all([__webpack_require__.e(2995), __webpack_require__.e(6717), __webpack_require__.e(8008), __webpack_require__.e(8401), __webpack_require__.e(526), __webpack_require__.e(5808)]).then(() => (() => ((__webpack_require__(95808)))));
	},
	"./routes": () => {
		return __webpack_require__.e(1210).then(() => (() => ((__webpack_require__(51210)))));
	},
	"./DashboardWrapper": () => {
		return Promise.all([__webpack_require__.e(2995), __webpack_require__.e(6717), __webpack_require__.e(8008), __webpack_require__.e(8401), __webpack_require__.e(526), __webpack_require__.e(5808), __webpack_require__.e(3050), __webpack_require__.e(6616), __webpack_require__.e(7694)]).then(() => (() => ((__webpack_require__(7694)))));
	},
	"./colors": () => {
		return __webpack_require__.e(6760).then(() => (() => ((__webpack_require__(96760)))));
	},
	"./TableWrapper": () => {
		return Promise.all([__webpack_require__.e(2995), __webpack_require__.e(6717), __webpack_require__.e(8008), __webpack_require__.e(8401), __webpack_require__.e(526), __webpack_require__.e(5808), __webpack_require__.e(8718)]).then(() => (() => ((__webpack_require__(66337)))));
	},
	"./UploadWrapper": () => {
		return Promise.all([__webpack_require__.e(2995), __webpack_require__.e(6717), __webpack_require__.e(8008), __webpack_require__.e(8401), __webpack_require__.e(526), __webpack_require__.e(9917), __webpack_require__.e(5808), __webpack_require__.e(6616), __webpack_require__.e(4283), __webpack_require__.e(6008)]).then(() => (() => ((__webpack_require__(23627)))));
	},
	"./TextEditor": () => {
		return Promise.all([__webpack_require__.e(2995), __webpack_require__.e(6717), __webpack_require__.e(8008), __webpack_require__.e(8401), __webpack_require__.e(526), __webpack_require__.e(9917), __webpack_require__.e(5808), __webpack_require__.e(6616), __webpack_require__.e(9165), __webpack_require__.e(3902)]).then(() => (() => ((__webpack_require__(11521)))));
	},
	"./store": () => {
		return Promise.all([__webpack_require__.e(8246), __webpack_require__.e(7731), __webpack_require__.e(2995), __webpack_require__.e(3050), __webpack_require__.e(4641)]).then(() => (() => ((__webpack_require__(84641)))));
	},
	"./main-client": () => {
		return Promise.all([__webpack_require__.e(2995), __webpack_require__.e(8008), __webpack_require__.e(8401), __webpack_require__.e(6616), __webpack_require__.e(7642)]).then(() => (() => ((__webpack_require__(77642)))));
	},
	"./helpers": () => {
		return Promise.all([__webpack_require__.e(2995), __webpack_require__.e(6717), __webpack_require__.e(8008), __webpack_require__.e(8401), __webpack_require__.e(526), __webpack_require__.e(9917), __webpack_require__.e(5808), __webpack_require__.e(8428)]).then(() => (() => ((__webpack_require__(76047)))));
	},
	"./useUpdateLoggedUser": () => {
		return Promise.all([__webpack_require__.e(3050), __webpack_require__.e(1321)]).then(() => (() => ((__webpack_require__(23702)))));
	},
	"./useGetAppSettings": () => {
		return Promise.all([__webpack_require__.e(8246), __webpack_require__.e(7731), __webpack_require__.e(2995), __webpack_require__.e(3050), __webpack_require__.e(1639)]).then(() => (() => ((__webpack_require__(64020)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope) => {
	if (!__webpack_require__.S) return;
	var name = "default"
	var oldScope = __webpack_require__.S[name];
	if(oldScope && oldScope !== shareScope) throw new Error("Container initialization failed as it has already been initialized with a different share scope");
	__webpack_require__.S[name] = shareScope;
	return __webpack_require__.I(name, initScope);
};

// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});